import {BulleAide, Question} from '@amo/core/components/containers';
import { LargeSpinner } from '@amo/core/components/loaders';
import {
    Civilite,
    Immatriculation,
    Nom,
    NomNaissance,
    NumeroSerie,
    PaysNaissance,
    Prenom,
    VilleNaissance,
} from '@amo/core/components/questions';
import { InformationEntreprise } from '@amo/core/components/questions/InformationEntreprise/InformationEntreprise.jsx';
import { getAddress, postLogConsent } from '@amo/core/utils/requestsApi';
import { validateImmatriculation, validatePhone } from '@amo/core/utils/validateField';
import _ from 'lodash';
import { useEffect, useState } from 'react';
import Adresse from './Adresse/Adresse';
import Email from './Email/Email';
import {ImmatOuMarquage} from '@amo/core/components/questions';
import NumeroTel from './NumeroTel/NumeroTel';
import Permis from './Permis/Permis';
import MessageNomPrenom from "./MessageNomPrenom/MessageNomPrenom.jsx";
import {getTranslation} from "@amo/core/utils/index.js";
import BoutonsAdresseDejaClient from "./BoutonsAdresseDejaClient/BoutonsAdresseDejaClient.jsx";
import info from '@amo/core/assets/images/icons/info.svg';

const InformationsSouscripteur = (props) => {
    const { data, postSaveDevis, saveDevisLoading, dejaClientData, valid, nameWhitelabel, token, canal } = props;
    const isDejaClient = !_.isEmpty(dejaClientData);
    const isAprilMoto = nameWhitelabel === 'APRIL Moto';
    const rgpdLetterUrl = isAprilMoto
        ? 'https://www.april-moto.com/wp-content/uploads/2021/11/Lettre-RGPD-APRIL-Moto-AM21-11.pdf'
        : 'https://www.amgestionassurance.com/Doc/Lettre-RGPD-AM-Gestion-11.2021.pdf';
    const IndexSouscripteur = _.includes(['true', '1', true], _.get(data, 'DemandeTarif[ListePersonnes][0][ConducteurMineur]'), )
        ? 1
        : 0;
    const [hasSearchAddress, setHasSearchAddress] = useState(false);
    const [tryPost, setTryPost] = useState(false);
    const [immatDisabled, setImmatDisabled] = useState(_.get(data, 'DemandeTarif[Vehicule][Immatriculation]') && _.get(data, 'searchBy') === 'immatriculation');

    useEffect(() => {
        if (tryPost) {
            isNotValid();
        }
    }, [data, tryPost]);

    /* Function qui ajoute la class error sur les champs vide */
    const handleError = (fieldName, remove) => {
        if (document.getElementsByName(fieldName).length > 0) {
            _.forEach(document.getElementsByName(fieldName), (input) => {
                if (input.getAttribute('type') === 'radio') {
                    if (remove) {
                        input.labels[0].classList.remove('error');
                    } else {
                        input.labels[0].classList.add('error');
                    }
                } else {
                    if (remove) {
                        input.classList.remove('error');
                    } else {
                        input.classList.add('error');
                    }
                }
            });
        } else {
            /* Gestion des autocomplete */
            if (remove) {
                document.querySelectorAll(`[data-name='${fieldName}']`)[0]?.classList.remove('error');
            } else {
                document.querySelectorAll(`[data-name='${fieldName}']`)[0]?.classList.add('error');
            }
        }
    };

    const isNotValid = () => {
        let notValid = false;
        let fields = [
            _.get(data, 'titulaireCarteGrise') !== '2'
                ? `DemandeTarif[ListePersonnes][${IndexSouscripteur}][Civilite]`
                : `DemandeTarif[ListePersonnes][1][Nom]`,
            _.get(data, 'titulaireCarteGrise') !== '2'
                ? `DemandeTarif[ListePersonnes][${IndexSouscripteur}][Nom]`
                : `DemandeTarif[ListePersonnes][1][LegalStatus]`,
            _.get(data, 'titulaireCarteGrise') !== '2'
                ? `DemandeTarif[ListePersonnes][${IndexSouscripteur}][BirthName]`
                : `DemandeTarif[ListePersonnes][1][IdSociety]`,
            _.get(data, 'titulaireCarteGrise') !== '2'
                ? `DemandeTarif[ListePersonnes][${IndexSouscripteur}][Prenom]`
                : '',
            _.get(data, 'titulaireCarteGrise') !== '2'
                ? `DemandeTarif[ListePersonnes][${IndexSouscripteur}][BirthCountry]`
                : '',
            _.get(data, 'titulaireCarteGrise') !== '2'
                ? `DemandeTarif[ListePersonnes][${IndexSouscripteur}][BirthCity]`
                : '',
            _.includes(['true', '1', true], _.get(data, 'DemandeTarif[ListePersonnes][0][ConducteurMineur]'))
                ? `DemandeTarif[ListePersonnes][0][Civilite]`
                : '',
            _.includes(['true', '1', true], _.get(data, 'DemandeTarif[ListePersonnes][0][ConducteurMineur]'))
                ? `DemandeTarif[ListePersonnes][0][Nom]`
                : '',
            _.includes(['true', '1', true], _.get(data, 'DemandeTarif[ListePersonnes][0][ConducteurMineur]'))
                ? `DemandeTarif[ListePersonnes][0][BirthName]`
                : '',
            _.includes(['true', '1', true], _.get(data, 'DemandeTarif[ListePersonnes][0][ConducteurMineur]'))
                ? `DemandeTarif[ListePersonnes][0][Prenom]`
                : '',
            `DemandeTarif[ListePersonnes][0][TelPortable]`,
            `DemandeTarif[ListePersonnes][0][Email]`,
            `EmailValidation`,
            `DemandeDevis[EmailContactConsent]`,
        ];

        if(isDejaClient) {
            fields.push('DejaClient[Ville]')
            fields.push('DejaClient[CP]')
            fields.push('DejaClient[Adresse1]')
        } else {
            fields.push('DemandeTarif[ListePersonnes][0][Ville]')
            fields.push('DemandeTarif[ListePersonnes][0][CP]')
            fields.push('DemandeTarif[ListePersonnes][0][Adresse1]')
        }

        fields.forEach((field) => {
            if (!_.get(data, field) && field !== '') {
                handleError(field);
                notValid = true;
            } else {
                handleError(field, true);
            }
        });

        if (_.get(data, 'immatriculation_check') !== '0') {
            if (validateImmatriculation(_.get(data, 'DemandeTarif[Vehicule][Immatriculation]'))) {
                notValid = true;
            }
        }

        if (validatePhone(_.get(data, 'DemandeTarif[ListePersonnes][0][TelPortable]'))) {
            notValid = true;
        }

        if(isDejaClient && _.get(data, 'DejaClient[Validate]') === false) {
            handleError('DejaClient[Adresse1]');
            notValid = true;
        }

        return notValid;
    };

    /* Envoie d'une fonction de validation  */

    const myPostSaveDevis = async () => {
        setTryPost(true);
        if (isNotValid()) {
            document.getElementsByClassName('error')[0]?.scrollIntoView({ behavior: 'smooth', block: 'center' });
        } else {
            if (hasSearchAddress) {
                const address = _.get(data, 'DejaClient[Validate]') === true
                    ? _.get(data, 'DejaClient[Adresse1]')
                    : _.get(data, 'DemandeTarif[ListePersonnes][0][Adresse1]');
                getAddress(address, 'ValidateForm');
            }
            const personne = data?.DemandeTarif?.ListePersonnes?.[0];
            postLogConsent({
                token,
                canal,
                phone: personne?.TelPortable ?? '',
                email: personne?.Email ?? '',
                email_contact_consent: data?.DemandeDevis?.EmailContactConsent ?? false,
                type: 'souscription',
            });
            postSaveDevis();
        }
    };

    return (
        <>
            {saveDevisLoading ? (
                <LargeSpinner message={getTranslation('informationsSubcriptor.loadingQuote')} />
            ) : (
                <div id={'etape-informations'} className={'fade-in'}>
                    <Question
                        loader
                        icon={info}
                        title={
                            _.includes(
                                ['true', '1', true],
                                _.get(data, 'DemandeTarif[ListePersonnes][0][ConducteurMineur]'),
                            )
                                ? getTranslation('informationsSubscriptor.subscriptorCoordonnees')
                                : getTranslation('informationsSubscriptor.yourCoordonnees')
                        }
                    >
                        {_.get(data, 'titulaireCarteGrise') !== '2' ? (
                            <>
                                <Civilite {...props} index={IndexSouscripteur} />
                                <Nom {...props} index={IndexSouscripteur} disabled={isDejaClient && _.get(data, 'DejaClient[Validate]') !== false} />
                                <NomNaissance {...props} index={IndexSouscripteur} required />
                                <Prenom {...props} index={IndexSouscripteur} disabled={isDejaClient && _.get(data, 'DejaClient[Validate]') !== false} />
                                {
                                    (data?.DemandeTarif?.ListePersonnes[IndexSouscripteur]?.Prenom &&
                                        (
                                            _.toLower(data?.DemandeTarif?.ListePersonnes[IndexSouscripteur]?.Nom) === _.toLower(data?.DemandeTarif?.ListePersonnes[IndexSouscripteur]?.Prenom) ||
                                            _.toLower(data?.DemandeTarif?.ListePersonnes[IndexSouscripteur]?.BirthName) === _.toLower(data?.DemandeTarif?.ListePersonnes[IndexSouscripteur]?.Prenom)
                                        )
                                    ) && <MessageNomPrenom/>
                                }
                            </>
                        ) : (
                            <>
                                <InformationEntreprise needAdresse={true} isDejaClient={isDejaClient} {...props} />
                            </>
                        )}

                        <Adresse {...props} isDejaClient={isDejaClient} setHasSearchAddress={setHasSearchAddress} />

                        {isDejaClient && <BoutonsAdresseDejaClient hasSearchAddress={hasSearchAddress} handleError={handleError} {...props} />}

                        <NumeroTel {...props} />

                        {
                            _.get(data, 'titulaireCarteGrise') !== '2' && <>
                                <PaysNaissance {...props} index={IndexSouscripteur} required />
                                <VilleNaissance {...props} index={IndexSouscripteur} required />
                            </>
                        }

                        <Email {...props} />
                    </Question>

                    {(_.includes(
                        ['true', '1', true],
                        _.get(data, 'DemandeTarif[ListePersonnes][0][ConducteurMineur]'),
                    ) ||
                        _.get(data, 'titulaireCarteGrise') === '2') && (
                        <Question icon={info} title={'Coordonnées du conducteur'} loader>
                            <Civilite {...props} index={0} />
                            <Nom {...props} index={0} disabled={isDejaClient && _.get(data, 'DejaClient[Validate]') !== false} />
                            <NomNaissance {...props} index={0} required />
                            <Prenom {...props} index={0} disabled={isDejaClient && _.get(data, 'DejaClient[Validate]') !== false} />
                            {
                                (data?.DemandeTarif?.ListePersonnes[0]?.Prenom &&
                                    (
                                        _.toLower(data?.DemandeTarif?.ListePersonnes[0]?.Nom) === _.toLower(data?.DemandeTarif?.ListePersonnes[0]?.Prenom) ||
                                        _.toLower(data?.DemandeTarif?.ListePersonnes[0]?.BirthName) === _.toLower(data?.DemandeTarif?.ListePersonnes[0]?.Prenom)
                                    )
                                ) && <MessageNomPrenom/>
                            }
                            <PaysNaissance {...props} index={0} required />
                            <VilleNaissance {...props} index={0} required />
                        </Question>
                    )}

                    <Question title={'Informations complémentaires'} loader>
                        <Permis {...props} />

                        {_.get(data, 'DemandeTarif[Vehicule][VehiculeImmatricule]') === '0' || _.get(data, 'immatriculation_check') === '0' ? (
                            <>
                                <NumeroSerie {...props} />
                                <BulleAide
                                    icon={info}
                                    title={'Vous avez une immatriculation ?'}
                                    text={'Si vous avez une immatriculation, merci de modifier votre déclaration en début de parcours'}
                                    className={'mt-0 col-lg-8 offset-lg-2 col-md-12'}
                                />
                                <ImmatOuMarquage {...props} />
                            </>
                        ) : (
                            <>
                                <Immatriculation {...props} disabled={immatDisabled} />
                                <ImmatOuMarquage {...props} />
                            </>
                        )}
                    </Question>

                    <div className={'row justify-content-center mt-3'}>
                        <div className={'col-lg-8 col-md-10 col-sm-10 col-12'}>
                            <small className={'text-start d-block f-12'}>
                                {getTranslation('callMeBack.rgpdInfo', { nameWhitelabel: isAprilMoto ? 'APRIL Moto' : 'AM Gestion' })}{' '}
                                <a
                                    href={rgpdLetterUrl}
                                    target={'_blank'}
                                    rel="noopener noreferrer"
                                >
                                    {getTranslation('callMeBack.rgpdLinkText')}
                                    <span className="visually-hidden"> (nouvelle fenêtre)</span>
                                </a>
                                .
                            </small>
                        </div>
                    </div>

                    <button className={`btn btn-primary btn-arrow mt-4 ${!valid && 'disabled'}`} onClick={!valid ? null : () => myPostSaveDevis()}>
                        {_.get(data, 'typeDevis') === 'subscribe' ? getTranslation('continue') : getTranslation('informationsSubscriptor.recieveMyQuote')}
                    </button>
                </div>
            )}
        </>
    );
};

export default InformationsSouscripteur;
